/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function Examination({ width = 18, height = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20.03 20.018"
    >
      <path
        id="Path_9001"
        data-name="Path 9001"
        d="M19.616,7.764l-.788-.788a1.385,1.385,0,0,0-1.966,0L14.737,9.1V1.787A1.671,1.671,0,0,0,13.068.118H4.219A1.678,1.678,0,0,0,3.035.606L.488,3.153A1.649,1.649,0,0,0,0,4.33V18.467a1.671,1.671,0,0,0,1.669,1.669h11.4a1.671,1.671,0,0,0,1.669-1.669V14.608L19.616,9.73A1.373,1.373,0,0,0,19.616,7.764ZM3.2,2.018v1.3H1.9ZM13.626,18.47a.557.557,0,0,1-.557.557H1.669a.557.557,0,0,1-.557-.557V4.429H3.754a.557.557,0,0,0,.557-.557V1.23h8.757a.557.557,0,0,1,.557.557v8.424L9.77,14.07a.559.559,0,0,0-.162.4v1.966a.557.557,0,0,0,.557.557h1.966a.583.583,0,0,0,.4-.162l1.1-1.1-.007,2.748Zm-1.732-2.6H10.717V14.7l5.429-5.433,1.178,1.178Zm6.933-6.933-.712.712L16.937,8.476l.712-.712a.281.281,0,0,1,.4,0l.785.785A.274.274,0,0,1,18.827,8.941Z"
        transform="translate(0 -0.118)"
        fill="#8c8c8c"
      />
    </svg>
  );
}

export default Examination;
